import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { CheckSquare, Trash2, X } from 'lucide-react';

interface BulkSelectionToolbarProps {
  selectedCount: number;
  itemLabel?: string;
  className?: string;
  onClear: () => void;
  onDelete?: () => void;
  deleteLabel?: string;
  deleteDisabled?: boolean;
}

export function BulkSelectionToolbar({
  selectedCount,
  itemLabel = 'baris',
  className,
  onClear,
  onDelete,
  deleteLabel = 'Hapus Terpilih',
  deleteDisabled = false,
}: BulkSelectionToolbarProps) {
  if (selectedCount <= 0) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 rounded-xl border bg-muted/40 px-4 py-3',
        className
      )}
    >
      <div className="flex items-center gap-2 text-sm font-medium">
        <CheckSquare className="h-4 w-4 text-primary" />
        <span>
          {selectedCount} {itemLabel} dipilih
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" type="button" onClick={onClear}>
          <X className="mr-2 h-4 w-4" />
          Bersihkan
        </Button>
        {onDelete ? (
          <Button variant="destructive" size="sm" type="button" onClick={onDelete} disabled={deleteDisabled}>
            <Trash2 className="mr-2 h-4 w-4" />
            {deleteLabel}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
